class RecentlyViewed extends HTMLElement {
  connectedCallback() { this.grid = this.querySelector('[data-recent-grid]'); this.clearButton = this.querySelector('[data-clear-history]'); this.fallback = this.grid?.innerHTML || ''; this.clearButton?.addEventListener('click', this.clear); this.consentHandler = () => this.setup(); document.addEventListener('visitorConsentCollected', this.consentHandler); this.loadConsent(); }
  disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); this.clearButton?.removeEventListener('click', this.clear); document.removeEventListener('visitorConsentCollected', this.consentHandler); }
  /**
   * The consent API is optional. Previously, if `Shopify.loadFeatures` was absent or
   * the script never resolved, setup() never ran and history was never recorded, so
   * the section stayed on its fallback forever. Now an absent API falls through to
   * "allowed" after a grace period; only an explicit refusal blocks it.
   */
  loadConsent() {
    if (window.Shopify?.customerPrivacy) { this.setup(); return; }
    if (window.Shopify?.loadFeatures) {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => this.setup());
    }
    this.graceTimer = setTimeout(() => this.setup(true), 1500);
  }

  setup(apiOptional = false) {
    if (this.initialized) return;
    const allowed = window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.();
    if (allowed === false) return;
    if (allowed !== true && !apiOptional) return;

    this.initialized = true;
    clearTimeout(this.graceTimer);
    const current = this.validUrl(this.dataset.currentUrl);
    if (!current) return;
    const now = Date.now();
    const expiry = 30 * 24 * 60 * 60 * 1000;
    const history = this.read().filter((item) => item && now - item.viewedAt < expiry && this.validUrl(item.url) && item.url !== current);
    const previous = history.slice(0, Number(this.dataset.limit) || 4);
    this.write([{ url: current, viewedAt: now }, ...history].slice(0, 12));
    if (!previous.length) return;
    if (this.clearButton) this.clearButton.hidden = false;
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) { this.observer.disconnect(); this.render(previous); }
    }, { rootMargin: '300px' });
    this.observer.observe(this);
  }
  read() { try { const value = JSON.parse(localStorage.getItem(this.dataset.storageKey) || '[]'); return Array.isArray(value) ? value : []; } catch { return []; } }
  write(value) { try { localStorage.setItem(this.dataset.storageKey, JSON.stringify(value)); } catch { /* Storage can be unavailable in private contexts. */ } }
  validUrl(value) { try { const url = new URL(value, location.origin); return url.origin === location.origin && /\/products\//.test(url.pathname) ? `${url.pathname}` : null; } catch { return null; } }
  /** Any card that fails to fetch is dropped; the fallback stays if none succeed. */
  async render(items) {
    if (!this.grid) return;
    this.controller = new AbortController();
    this.setAttribute('aria-busy', 'true');
    try {
      const cards = await Promise.all(items.map((item) => this.fetchCard(item.url)));
      const validCards = cards.filter(Boolean);
      if (!validCards.length) return;
      this.grid.replaceChildren(...validCards);
      this.dataset.historyLoaded = 'true';
    } catch (error) {
      /* Keep the server-rendered fallback in place. */
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
  /**
   * Fetches one card from the alternate `recent-card` view.
   *
   * This used to also send `section_id=card`, which made every request 404: the
   * Section Rendering API resolves section ids against the product's normal
   * template, which has no section by that name. With it removed the view renders
   * and the fragment is found, which is what makes this section work at all.
   */
  async fetchCard(path) { try { const url = new URL(path, location.origin); url.searchParams.set('view', 'recent-card'); const response = await fetch(url, { signal: this.controller.signal }); if (!response.ok) return null; const parsed = new DOMParser().parseFromString(await response.text(), 'text/html'); parsed.querySelectorAll('style').forEach((style) => { const key = `recent-style-${style.textContent.length}`; if (!document.querySelector(`[data-${key}]`)) { style.setAttribute(`data-${key}`, ''); document.head.append(style); } }); return parsed.querySelector('.recent-card-fragment')?.firstElementChild || null; } catch { return null; } }
  clear = () => { try { localStorage.removeItem(this.dataset.storageKey); } catch { /* Ignore blocked storage. */ } if (this.grid) this.grid.innerHTML = this.fallback; this.clearButton.hidden = true; this.dataset.historyLoaded = 'false'; };
}
if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);